module.exports = "https://static.wagwalking.com/_next/static/images/DropIn_Mobile-ff452f9e2ace55d78b45d7638732f0c6.png";